export default {
  'component.b2bservice.purchase.title': 'Aktive Flex tjenester',
  'component.b2bservice.title': 'B2B tjenester',
  'component.b2bservice.purchase': 'Bestill',
};
